
//=============================================================================
// Contents   : HRDB
//              人事稟議一覧画面
//              GetApprovalList
// Author     : RV小寺
// LastUpdate : 2023/3/24
// Since      : 2022/12/2
//=============================================================================

/* ======================================================================================================================================================= */  
/* ==================================================================== Start Of Program ================================================================= */  
/* ======================================================================================================================================================= */ 


/* ======================================================================== */  
/* ============================ import ==================================== */  
/* ======================================================================== */  

/* ====== React ====== */
import React from "react";

/* ====== CSS ====== */

/* ====== Image ====== */

/* ====== Component Js/Jsx ====== */
/* ====== Style ====== */
import { GetListTemp } from "01Pages/Template/GetListTemp";
/* ======================================================================== */  
/* ============================ Styles ==================================== */  
/* ======================================================================== */  

/* ======================================================================== */  
/* ================== global variables/functions ========================== */  
/* ======================================================================== */  
/* ベース64スイッチ */

/* ======================================================================== */  
/* ================================ dummy ================================= */  
/* ======================================================================== */  

/* ======================================================================== */  
/* ============================ Main ====================================== */  
/* ======================================================================== */  

/* ========= 人事稟議情報一覧 ========= */
export const GetApprovalList = () => {

    /* ---------------------------------------------------- */
    /* ------------------ Instance ------------------------ */
    /* ---------------------------------------------------- */

    /* ----------------------------------------------------- */
    /* ----------------- reack-hook-form ------------------- */
    /* ----------------------------------------------------- */

    /* ====== useWatchを定義 ====== */ 

    /* ---------------------------------------------------- */
    /* ------------------ variables ----------------------- */
    /* ---------------------------------------------------- */
    /* ====== コードマスタ・マスタを定義 ====== */ 
    /* ====== sessionStorageからの情報を定義 ====== */ 

    /* ====== localStorageからの情報を定義 ====== */ 

    /* ====== storageから取得した情報をJavaScriptオブジェクトに変換 ====== */ 


    /* ---------------------------------------------------- */
    /* ---------------------- state ----------------------- */
    /* ---------------------------------------------------- */

    /* ---------------------------------------------------- */
    /* ---------------------- function -------------------- */
    /* ---------------------------------------------------- */
    /* ---------------------------------------------------- */
    /* ----------------------- data ----------------------- */
    /* ---------------------------------------------------- */
    /* ====== 取得API項目の設定 ====== */
	const getConfig = {
        key:[
            {name:'sarYear' ,           base64:false},
            {name:'orgEmpFullName' ,    base64:true},
            {name:'acptaRquSttFlag' ,   base64:false},
            {name:'acptaNtRquFlag' ,    base64:false},
        ],
        payload:[
            {name:'hrAprvNmb',             base64:false},
            {name:'orgnrEmpNmb',           base64:false},
            {name:'orgEmpFullName',      base64:true},
            {name:'hireDptCd',             base64:false},
            {name:'hireDptOrd',            base64:false},
            {name:'hireDptName',           base64:true},
            {name:'aprvOrgTimeCst',        base64:false},
            {name:'indexNmbDate',          base64:false},
            {name:'acptaRquFlag',          base64:false},
            {name:'acptaEmpNmb',           base64:false},
            {name:'acptaEmpFullName',      base64:true},
            {name:'invalidFlag',              type:Boolean, base64:false},
            {name:'lastUdr',               base64:true},
            {name:'lastUpDate',            base64:false},
        ]              
    };
    /* ====== 更新API項目の設定 ====== */
    const updateConfig = {
        key:['hrAprvNmb'],
        payload:[
            {name:'invalidFlag',    type:Boolean},
        ]              
    }
    /* ======== テーブルの設定 ======== */
    /*------ ヘッダの設定 ------*/
    // id       : 項目名
    // rowSpan  : 2~ (縦に結合)
    // colSpan	: 2~ (横に結合)
    // align	: 整列(横方向) Center/inherit/justify/left/right
    // sortTable: true(ソート)
    // fixed	: 位置固定 true
    // left		: 左からの位置	0~
    // right	: 右からの位置 0~
    // width    : セルの幅
    // label1	: 表示名(1段目)
    // label2	: 表示名(2段目)
    // mark     : 入力必須を表す*を表示　true

    /* ====== テーブルヘッダーを定義 ====== */
    const headData = [
    	{ id: 'hrAprvNmb', align: 'left', width: '145px', sortTable:true, label1:'人事稟議番号'},
    	{ id: 'orgnrEmpNmb',align: 'left', width: '175px', sortTable:true, label1: '起案者従業員番号'},
    	{ id: 'orgEmpFullName',align: 'left', width: '120px', sortTable:true, label1: '起案者名'},
        { id: 'hireDptCd',align: 'left', width: '160px', sortTable:true, label1: '採用部署コード'},
        { id: 'hireDptName',align: 'left', width: '400px', sortTable:true, label1: '採用部署'},
        { id: 'aprvOrgTimeCst', align: 'left', width: '80px', sortTable:true, label1: '費用' },
        { id: 'indexNmbDate', align: 'left', width: '110px', sortTable:true, label1: '採番日時' },
        { id: 'acptaRquFlag', align: 'left', width: '95px', sortTable:true, label1: '受入申請' },
        { id: 'acptaEmpNmb', align: 'left', width: '175px', sortTable:true, label1: '受入者従業員番号' },
        { id: 'acptaEmpFullName',align: 'left', width: '130px', sortTable:true, label1: '従業員名' },
        { id: 'lastUdr',align: 'left', width: '130px', sortTable:true, label1: '最終更新者' },
        { id: 'lastUpDate',align: 'left', width: '120px', sortTable:true, label1: '最終更新日' },
        { id: 'invalidFlag', align: 'center', width: '90px', sortTable:true, label1: '無効' },
    ];

    /*====== BodyCellの設定 ======*/
    // name		    : 項目名
    // name2		: 項目名2 値を２つ受け取りたい場合
    // type         : cellの種類　button/checkBox/lable/numLable/labelRaito/labelMonth
    // align	    : 整列(横方向) Center/inherit/justify/left/right *全て（ただしinputの場合はinputの中の文字の位置を指定）
    // width        : selectの幅調整用
    // color        : 文字の色
    // backgroundColor: 背景の色
    // checkBox     : チェックボックスの名前  *input,checkBox
    // fontSize	    : 文字の大きさ デフォルトは12px *label,labelNum
    // color	    : フォントカラーまたはアイコンカラー(アイコンの場合はred/green/grayが選択可能) *label,labelNum,iconButton
    // func         : 処理 *button,iconButton,select
    // value		: btnFuncで受け取りたい値 *button,iconButton

    /* ====== テーブルデータを定義 ====== */
    const bodyData = [
        { name: 'hrAprvNmb', type: 'label',  align: 'left'},
        { name: 'orgnrEmpNmb',type: 'label',  align: 'left'},
        { name: 'orgEmpFullName',type: 'label',  align: 'left'},
        { name: 'hireDptCd', type: 'label',  align: 'left'},
        { name: 'hireDptName', type: 'label',  align: 'left'},
        { name: 'aprvOrgTimeCst', type: 'moneyLabel',  align: 'right'},
        { name: 'indexNmbDate', type: 'timeLabel',  align: 'left'},
        { name: 'acptaRquFlag', type: 'edit',masterType:'codeMaster', master: 'acceptanceRequestFlag',  align: 'left'},
        { name: 'acptaEmpNmb', type: 'label',  align: 'left'},
        { name: 'acptaEmpFullName',type: 'label',  align: 'left'},
        { name: 'lastUdr',type: 'label',  align: 'left'},
        { name: 'lastUpDate',type: 'timeLabel',  align: 'left'},
        { name: 'invalidFlag', type: 'check',  align: 'center', disabled: true},
    ];
    /* ======== 編集モードのテーブルデータ　=======*/
    /* データをコピー */
    const editBodyData = [...bodyData];
    /* 編集モード時に表示が切り替わるデータ */
    const editableItem = [
        { name: 'invalidFlag', type: 'check',  align: 'center',masterType:'codeMaster', master: 'acceptanceRequestFlag',},
    ];
    /* 切り替わるデータを回して、置換していく */
    editableItem.forEach((item)=>{
        const index = editBodyData.findIndex(e=>e.name === item.name);
        editBodyData.splice(index,1,item);
    });

    /* ======== ページヘッダーの設定 ======== */
    /*------ ページヘッダーの設定 ------*/
    // id         : 項目名
    // name       : 項目名
    // type       : 種類 input/select/checked/searchButton/clearButton/inputList
    // range      : selectbox中身
    // type       : 種類 input/select/checked/searchButton/clearButton
    // width      : 幅幅調整用
    // maxLength  : 最大桁数を定義
    // minLength  : 最小桁数を定義
    // placeholder: Input内のテキスト
    // required   : 必須定義
    // disabled   : 操作不可
    // func       : 処理 *button,iconButton,select
    // checked    :defoltCheckを定義

    /* ====== 検索欄(左)を定義 ====== */
    /* 今日の日付を取得 */
    let today = new Date();
    /* yyyy-mm-ddの形に変える */
    const year = `${today.getFullYear()}`;//年を取得
    const searchContentsLeft = [
        {id:'sarYear', name:'検索年', type:'year'},
        {id:'orgEmpFullName',name:'起案者',type:'input', width:'140px', maxLength: 50, pattern: 'space'},
        {name:'受入申請：',type:'label'},
        {id:'acptaNtRquFlag',name:'未',type:'checked', checked: 'defaultChecked'},
        {id:'acptaRquSttFlag',name:'済',type:'checked'},
        {id:'search',type:'searchButton'},
        {id:'clear',type:'clearButton'},
    ];

    const defaultSearch = {
        sarYear: year,
        orgEmpFullName:'',
        hireDptCd:'',
        acptaRquSttFlag:true,
        acptaNtRquFlag:false,
    }

    /* ====== 検索欄(右)を定義 ====== */
    const searchContentsRight = [
        {id:'hireDptCd',id2:'hireDptName',ord:'hireDptOrd',name:'採用部署',type:'inputVariableList',width: '500px'},
    ];
    /* ====== マスタの取得を定義 ====== */
    /* ---------------------------------------------------- */
    /* ----------------------- jsx ------------------------ */
    /* ---------------------------------------------------- */

    /* ---------------------------------------------------- */
    /* -------------------- Start Render ------------------ */
    /* ---------------------------------------------------- */

    return(
        <>
			<GetListTemp
				listType='listEditable'//一覧タイプ(list:編集なし/listEditable:編集可/listOrderBy:表示順更新)
                initialSearch={true}//初期検索有無
                searchCount={true}//検索件数表示
				pageTitle='人事稟議一覧'//画面タイトル
                searchContentsLeft={searchContentsLeft}//検索欄左設定
                searchContentsRight={searchContentsRight}//検索欄右設定
				updateApiPath='/approval/updatedisablement'//一覧更新のApiPath
				apiPath='/approval/getlistapproval'//一覧取得のApiPath
                defaultSearch={defaultSearch}
				headData={headData}//テーブルヘッダ設定
                editHeadData={headData}//テーブルヘッダ設定(編集用)
				bodyData={bodyData}//テーブルボディ設定
				getConfig={getConfig}//テーブル取得設定
				updateConfig={updateConfig}//テーブル更新設定
				editBodyData={editBodyData}//テーブルボディ設定
			/>
        </>
    );
};

/* ======================================================================================================================================================= */  
/* ==================================================================== End Of Program =================================================================== */  
/* ======================================================================================================================================================= */ 